module.exports = __webpack_public_path__ + "static/media/BTC.f92890de.svg";